import ExperienceCard from './ExperienceCard';
import LTE from '../Assets/img/lte-logo.png';
import EEP from '../Assets/img/eep-logo.png';
import AUX from '../Assets/img/aux-logo.png';
import UR from '../Assets/img/ur-logo.svg';

// const experiences = [
//     {
//         company: "Auxilary.ai",
//         logo: AUX,
//         role: "Founding Engineer & Technical Architect",
//         duration: "December 2024 – Present",
//         location: "Remote, Oregon, USA",
//         link: "https://auxilary.ai",
//         highlights: [
//             "Built an AI-powered platform from scratch that lets users upload or import datasets (CSV, Excel, JSON, Google Sheets, MySQL, PostgreSQL, AWS S3) and clean them using NLP commands via OpenAI.",
//             "Designed the entire system architecture and tech stack; implemented backend (Node.js, Express, MySQL) and frontend (Next.js) with full autonomy.",
//             "Engineered data parsing, table mapping, and cleaning workflows with undo functionality and dataset versioning.",
//             "Developed a real-time NLP-to-SQL chat interface enabling intelligent data cleaning with statistical validation and visual feedback.",
//             "Created EDA tools including null counts, outlier detection, correlation heatmaps, and interactive summaries.",
//             "Integrated ML capabilities to allow users to run baseline models (classification/regression) and compare performance metrics.",
//             "Managed DevOps, deployments, and product roadmap single-handedly while translating vision into deliverables alongside the CEO."
//         ]
//     },
//     {
//         company: "Lighte-ticket",
//         logo: LTE,
//         role: "Full Stack Developer",
//         duration: "November 2022 – December 2024",
//         location: "Addis Ababa, Ethiopia",
//         highlights: [
//             "Led the development and deployment of a transportation management system, driving digital transformation and automating manual workflows.",
//             "Built and integrated CRUD features for core entities (vehicles, employees, terminals, trips) using React, Node.js, Express.js, and MySQL.",
//             "Developed a real-time dashboard delivering actionable analytics and performance insights, cutting processing time by 40%.",
//             "Integrated notifications and check-in/out logic, streamlining operations and improving response accuracy by 60%.",
//             "Achieved 90% test coverage using Jest, React Testing Library, and Cypress to ensure code reliability.",
//             "Deployed the system with Docker across four regional terminals, enhancing data management and creating 40+ jobs."
//         ]

//     },
//     {
//         company: "Ethiopian Electric Power",
//         logo: EEP,
//         role: "Mechanical Design Intern",
//         duration: "June 2021 - October 2021",
//         location: "Addis Ababa, Ethiopia",
//         highlights: [
//         "Designed mechanical components and systems for dam infrastructure projects, ensuring integrity and safety.",
//         "Collaborated with multidisciplinary teams to integrate mechanical systems into the overall dam structures, optimizing performance.",
//         "Spearheaded innovative dam project solutions, enhancing efficiency and cost-effectiveness.",
//         "Contributed to critical component design and analysis for various dam projects, ensuring structural integrity and safety compliance."
//         ]
//     }
// ];

const experiences = [
  {
    company: 'Unicorn Ranch',
    logo: UR,
    role: 'Full Stack Developer',
    duration: 'August 2025 – Present',
    location: 'Remote, United Kingdom',
    link: 'https://unicornranch.dev',
    highlights: [
      'Expanded OTA distribution to 68+ channels by integrating Channex with NestJS and PostgreSQL, enabling synchronized reservations, rates, and availability across connected channels.',
      'Built a customizable direct-booking platform with a React/TypeScript booking engine, reusable website templates, and AI-assisted page editing with draft/publish workflows.',
      'Implemented flexible reservation payments by integrating Stripe and RaiAccept with payment intents, webhooks, and payment-state handling, supporting online and pay-at-hotel payments, refunds, and booking amendments.',
      'Streamlined hotel operations by developing dashboards, REST APIs, role-based access, and housekeeping workflows, bringing reservations, room operations, and property management into one platform.',
      'Developed a real-time scooter fleet platform by integrating TCP-based GPS telemetry, device control, PostGIS geospatial data, and geofencing, enabling live fleet tracking and location-based operations.',
      'Built a headless e-commerce storefront using Qwik, Vendure, and GraphQL, implementing product discovery, cart, checkout, and pay-on-delivery workflows.',
    ],
  },
  {
    company: 'Auxilary.ai',
    logo: AUX,
    role: 'Founding Engineer & Full Stack Developer',
    duration: 'December 2024 – July 2026',
    location: 'Remote, United States',
    link: 'https://auxilary.ai',
    highlights: [
      'Built isolated Python execution infrastructure by orchestrating Docker, Jupyter Kernel Gateway, WebSockets, and Server-Sent Events (SSE), enabling interactive code execution with streamed outputs and persistent history.',
      'Developed a stateful AI notebook agent by implementing validated editing and execution tools, persistent sessions, and bounded execution iterations, enabling controlled AI-assisted data analysis.',
      'Automated dataset ingestion by integrating Amazon S3, CSV/Excel/JSON parsing, and dynamic MySQL tables, turning uploaded files into structured, queryable datasets.',
    ],
  },
  {
    company: 'Light E-Ticket',
    logo: LTE,
    role: 'Full Stack Developer',
    duration: 'November 2023 – December 2024',
    location: 'Addis Ababa, Ethiopia',
    highlights: [
      'Built a transportation operations platform using React, Node.js, Express.js, and MySQL to manage vehicles, employees, terminals, trips, and operational workflows.',
      'Developed destination-based vehicle queue management to organize vehicle dispatch and terminal operations.',
      'Implemented JWT authentication with bcrypt, short-lived access tokens, database-backed refresh tokens, and HTTP-only cookies.',
      'Built operational dashboards and Excel reporting to support transportation management and decision-making.',
      'Automated month-end vehicle blacklisting with retry handling, reducing manual operational work.',
      'Implemented API security measures including Helmet, rate limiting, CORS controls, XSS protection, and centralized error handling.',
    ],
  },
  {
    company: 'Ethiopian Electric Power',
    logo: EEP,
    role: 'Mechanical Design Intern',
    duration: 'June 2021 – October 2021',
    location: 'Addis Ababa, Ethiopia',
    highlights: [
      'Supported mechanical design and engineering work for dam infrastructure projects.',
      'Collaborated with multidisciplinary engineering teams on mechanical component design and analysis.',
    ],
  },
];

const ExperienceSection = () => {
  return (
    <section className="sectionContainer experienceContainer">
      <h1 className="sectionName">EXPERIENCE</h1>
      <h1 className="sectionHeadline">My Professional Journey 💼</h1>
      <div className="experience-section">
        {experiences.map((exp, index) => (
          <ExperienceCard key={index} {...exp} />
        ))}
      </div>
    </section>
  );
};

export default ExperienceSection;
